// Google Maps API key configuration
// The Maps JS API is always client-side by design.
// Secure your key with HTTP referrer restrictions in Google Cloud Console.

function getApiKey() {
  return window._GMAPS_KEY || '';
}

export function setApiKey(key) {
  window._GMAPS_KEY = key;
}

export function loadGoogleMapsScript(apiKey) {
  const key = apiKey || getApiKey();
  return new Promise((resolve, reject) => {
    if (window.google && window.google.maps) {
      resolve(window.google);
      return;
    }
    if (document.getElementById('google-maps-script')) {
      const check = setInterval(() => {
        if (window.google && window.google.maps) {
          clearInterval(check);
          resolve(window.google);
        }
      }, 100);
      return;
    }
    if (!key) {
      reject(new Error('No Google Maps API key provided'));
      return;
    }
    const script = document.createElement('script');
    script.id = 'google-maps-script';
    script.src = `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places&v=weekly`;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve(window.google);
    script.onerror = () => reject(new Error('Failed to load Google Maps'));
    document.head.appendChild(script);
  });
}

export async function getPlaceDetails(placeId) {
  await loadGoogleMapsScript();
  const place = new window.google.maps.places.Place({ id: placeId });
  await place.fetchFields({
    fields: ['displayName', 'formattedAddress', 'location', 'photos', 'regularOpeningHours', 'rating', 'websiteURI', 'nationalPhoneNumber'],
  });
  return place;
}

export function getMapsEmbedUrl(placeId) {
  const key = getApiKey();
  return `https://www.google.com/maps/embed/v1/place?key=${key}&q=place_id:${placeId}`;
}

export function getMapsLinkUrl(placeId) {
  return `https://www.google.com/maps/search/?api=1&query_place_id=${placeId}`;
}